import { create } from 'zustand';

export enum NotifyType {
  CreditCost = 'credit_cost',
  NotEnoughCredit = 'not_enough_credit',
}

export interface INotifyCreditCosts {
  open: boolean;
  showCloseIcon?: boolean;
  textBtn: string;
  type: NotifyType | null;
  creditCost: number;
  cbAction: () => void;
  cbClose: () => void;
}

export interface INotifyCreditCostsAction {
  handleCloseNotify: () => void;
  handleOpenNotify: ({
    textBtn,
    showCloseIcon,
    creditCost,
    cbAction,
    cbClose,
  }: {
    type: NotifyType;
    showCloseIcon?: boolean;
    textBtn?: string;
    creditCost?: number;
    cbAction?: () => void;
    cbClose?: () => void;
  }) => void;
}

export const useNotifyCreditCosts = create<INotifyCreditCosts & INotifyCreditCostsAction>((set) => {
  return {
    open: false,
    showCloseIcon: false,
    textBtn: '',
    type: null,
    creditCost: 0,
    cbAction: () => null,
    cbClose: () => null,
    handleCloseNotify: () => set(() => ({ open: false, type: null })),
    handleOpenNotify: ({
      type,
      textBtn,
      showCloseIcon,
      creditCost,
      cbAction,
      cbClose,
    }: {
      type: NotifyType;
      showCloseIcon?: boolean;
      textBtn?: string;
      creditCost?: number;
      cbAction?: () => void;
      cbClose?: () => void;
    }) => set(() => ({ open: true, type, textBtn, creditCost, showCloseIcon, cbAction, cbClose })),
  };
});
